import { getDataFromLocalStorage, getTokenFromLocalStorage } from 'utils/LocalStorage';
import { LOCAL_STORAGE_KEY } from 'constants/LocalStorageKeys';
import { resolveBackendUrl } from 'utils/backendUrl';

export const logFrontendError = async (errorData) => {
  try {
    const profile = getDataFromLocalStorage(LOCAL_STORAGE_KEY.profile);
    const userId = profile?._id || null;

    const payload = {
      message: errorData.message || 'Unknown error',
      stack: errorData.stack || null,
      errorType: errorData.errorType || 'error',
      componentStack: errorData.componentStack || null,
      url: errorData.url || window.location.href,
      userId: userId,
      timestamp: new Date().toISOString(),
      source: errorData.source || 'unknown',
      errorInfo: errorData.errorInfo || null,
    };

    const response = await fetch(`${resolveBackendUrl()}/common/log_error`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: getTokenFromLocalStorage(),
        currentbranchid: getDataFromLocalStorage(LOCAL_STORAGE_KEY.currentBranch) || '',
      },
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      console.warn('Failed to log error to backend:', response.status);
    }
  } catch (loggingError) {
    console.warn('Error logging failed:', loggingError);
  }
};

